export const AUTH_TOKEN_KEY = "auth-token";

export const clearStore = () => {
  const assetsView = localStorage.getItem("defaultView");
  localStorage.clear();
  if (assetsView) localStorage.setItem("defaultView", assetsView);
};
